import { MdOutlineRadioButtonChecked } from "react-icons/md";
import styles from "./ChangeLanguage.module.css";
import { useState } from "react";
import { useTranslation } from "react-i18next";
const ChangeLanguage = () => {
  const [SelectedLanguage, setSelectedLanguage] = useState(null);
  const { t, i18n } = useTranslation()
  const [LanguageList, setLanguageList] = useState([
    { id: '1', langauge: 'americanEnglish', value: 'en' },
    { id: '2', langauge: 'spanish', value: 'sp' },
  ]);
  const selectedLang = localStorage.getItem('@selectedLanguage');
  console.log("selectcedlang", selectedLang);
  // const dummyLanguage = [
  //   {
  //     id: 1,
  //     language: "English",
  //   },
  //   {
  //     id: 2,
  //     language: "Spanish",
  //   },
  // ];
  // const [selectedItem, setSelectedItem] = useState(LanguageList[0]?.id);
  
  const onSelectedLanguage =  (item) => {
    setSelectedLanguage(item?.id)
    i18n.changeLanguage(item.value)
    localStorage.setItem('@selectedLanguage', item?.value);
    console.log('////////', item.value);
  }
  return (
    <div className={styles.mainDiv}>
      <div className={styles.heading}>
        <h1>{t('changeLanguage')}</h1>
      </div>
      {LanguageList.map((item) => {
        return (
          <div
            className={styles.content}
            onClick={() => onSelectedLanguage(item)}
          >
            <input 
            style={{backgroundColor : SelectedLanguage == item?.id ? "var(--secondary-color)" : "#B7B7B7"}}
            onClick={() => onSelectedLanguage(item)}
            checked={item?.value == selectedLang ? true : false}
            type="radio"
            value={item?.langauge}
            name={item?.langauge}
               />
            {/* <MdOutlineRadioButtonChecked
              size={30}
              color={selectedItem == item?.id ? "var(--secondary-color)" : "#B7B7B7" }
            /> */}
            <h1>{t(item?.langauge)}</h1>
          </div>
        );
      })}
    </div>
  );
};
export default ChangeLanguage;
   